// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"152":"861d6d65","374":"4f6286b7","427":"615d6b73","630":"09fd1bea","674":"a4c87f97"}[chunkId] + ".js";
};